import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-forest text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="font-heading text-2xl font-bold mb-2">Sister Diamonds</h3>
            <p className="text-terracotta text-sm mb-4">A Volition Enterprises Company</p>
            <p className="text-white/70 mb-6 max-w-md">
              Empowering high-capacity women to walk in their power, speak their truth, 
              and build lives they don't need to escape from.
            </p>
            <div className="flex gap-4">
              <a href="https://sisterdiamonds.com" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors">
                Website
              </a>
              <a href="https://www.instagram.com/sisterdiamonds" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors">
                Instagram
              </a>
              <a href="https://www.linkedin.com/company/volition-enterprises" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors">
                LinkedIn
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/pathways" className="text-white/70 hover:text-white transition-colors">Pathways</Link></li>
              <li><Link to="/coaches" className="text-white/70 hover:text-white transition-colors">Our Coaches</Link></li>
              <li><Link to="/communities" className="text-white/70 hover:text-white transition-colors">Communities</Link></li>
              <li><Link to="/videos" className="text-white/70 hover:text-white transition-colors">The Vault</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Support</h4>
            <ul className="space-y-2">
              <li><a href="mailto:info@sisterdiamonds.com" className="text-white/70 hover:text-white transition-colors">Contact Us</a></li>
              <li><a href="https://sisterdiamonds.com/faq" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors">FAQ</a></li>
              <li><a href="https://sisterdiamonds.com/privacy" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="https://sisterdiamonds.com/terms" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors">Terms of Service</a></li>
            </ul>
          </div>
        </div>

        {/* Copyright & Legal Notice */}
        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2 text-white/50">
              <Shield className="h-4 w-4" />
              <p className="text-sm">
                &copy; {currentYear} Sister Diamonds, LLC. All rights reserved.
              </p>
            </div>
            <p className="text-xs text-white/40 text-center md:text-right max-w-md">
              Sister Diamonds&trade; is a registered trademark of Volition Enterprises, LLC. 
              This platform and all content are proprietary and protected by copyright law.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
